@if (visible()) {
  <div class="loading-splash-overlay">
    <div class="loading-splash-content">

      <!-- Animated Logo -->
      <div class="logo-container">
        <svg
          [class.active]="logoAnimating()"
          version="1.0"
          xmlns="http://www.w3.org/2000/svg"
          width="240"
          height="249"
          viewBox="0 0 240.000000 249.000000"
          preserveAspectRatio="xMidYMid meet"
        >
          <g transform="translate(0.000000,249.000000) scale(0.100000,-0.100000)" class="logo-fill" stroke="none">
            <path d="M1594 2249 c-41 -12 -84 -56 -84 -85 l0 -24 135 0 c125 0 135 1 135 19 0 21 -33 67 -58 80 -28 15 -95 20 -128 10z" class="svg-elem-1"></path>
            <path d="M755 2190 c-60 -13 -105 -52 -105 -92 0 -16 12 -18 135 -18 134 0 135 0 135 23 0 53 -93 102 -165 87z" class="svg-elem-2"></path>
            <path d="M1510 1975 l0 -125 135 0 135 0 0 125 0 125 -135 0 -135 0 0 -125z" class="svg-elem-3"></path>
            <path d="M1160 2043 c-34 -13 -69 -45 -78 -73 l-11 -30 140 0 c129 0 139 1 139 19 0 23 -42 68 -75 81 -28 11 -90 12 -115 3z" class="svg-elem-4"></path>
            <path d="M650 1930 l0 -110 135 0 135 0 0 110 0 110 -135 0 -135 0 0 -110z" class="svg-elem-5"></path>
            <path d="M2004 2006 c-33 -15 -74 -60 -74 -82 0 -11 28 -14 141 -14 l140 0 -7 23 c-21 71 -120 107 -200 73z" class="svg-elem-6"></path>
            <path d="M276 1931 c-30 -20 -55 -55 -56 -78 0 -10 34 -13 140 -13 77 0 140 3 140 6 0 25 -37 75 -65 88 -46 22 -123 20 -159 -3z" class="svg-elem-7"></path>
            <path d="M1080 1815 l0 -75 135 0 135 0 0 75 0 75 -135 0 -135 0 0 -75z" class="svg-elem-8"></path>
            <path d="M1930 1730 l0 -110 140 0 140 0 0 110 0 110 -140 0 -140 0 0 -110z" class="svg-elem-9"></path>
            <path d="M220 1725 l0 -75 140 0 141 0 -3 73 -3 72 -137 3 -138 3 0 -76z" class="svg-elem-10"></path>
            <path d="M650 1535 l0 -195 135 0 135 0 0 195 0 195 -135 0 -135 0 0 -195z" class="svg-elem-11"></path>
            <path d="M1504 1707 c-2 -7 -3 -71 -2 -143 l3 -129 138 -3 137 -3 0 146 0 145 -135 0 c-102 0 -137 -3 -141 -13z" class="svg-elem-12"></path>
            <path d="M1080 1650 c0 -19 7 -20 135 -20 128 0 135 1 135 20 0 19 -7 20 -135 20 -128 0 -135 -1 -135 -20z" class="svg-elem-13"></path>
            <path d="M220 1565 c0 -13 22 -15 140 -15 118 0 140 2 140 15 0 13 -22 15 -140 15 -118 0 -140 -2 -140 -15z" class="svg-elem-14"></path>
            <path d="M1080 1450 l0 -70 135 0 135 0 0 70 0 70 -135 0 -135 0 0 -70z" class="svg-elem-15"></path>
            <path d="M1930 1495 l0 -25 140 0 140 0 0 25 0 25 -140 0 -140 0 0 -25z" class="svg-elem-16"></path>
            <path d="M220 1380 l0 -70 140 0 140 0 0 70 0 70 -140 0 -140 0 0 -70z" class="svg-elem-17"></path>
            <path d="M1930 1290 l0 -70 140 0 140 0 0 70 0 70 -140 0 -140 0 0 -70z" class="svg-elem-18"></path>
            <path d="M1080 1260 l0 -70 135 0 135 0 0 70 0 70 -135 0 -135 0 0 -70z" class="svg-elem-19"></path>
            <path d="M1500 1165 l0 -75 140 0 140 0 0 75 0 75 -140 0 -140 0 0 -75z" class="svg-elem-20"></path>
            <path d="M220 1165 l0 -65 140 0 140 0 0 65 0 65 -140 0 -140 0 0 -65z" class="svg-elem-21"></path>
            <path d="M650 1115 l0 -95 135 0 135 0 0 95 0 95 -135 0 -135 0 0 -95z" class="svg-elem-22"></path>
            <path d="M1080 1110 c0 -19 7 -20 135 -20 128 0 135 1 135 20 0 19 -7 20 -135 20 -128 0 -135 -1 -135 -20z" class="svg-elem-23"></path>
            <path d="M220 1010 c0 -19 7 -20 140 -20 133 0 140 1 140 20 0 19 -7 20 -140 20 -133 0 -140 -1 -140 -20z" class="svg-elem-24"></path>
            <path d="M1930 925 l0 -95 140 0 140 0 0 95 0 95 -140 0 -140 0 0 -95z" class="svg-elem-25"></path>
            <path d="M1080 955 l0 -25 135 0 135 0 0 25 0 25 -135 0 -135 0 0 -25z" class="svg-elem-26"></path>
            <path d="M1500 850 l0 -130 140 0 140 0 0 130 0 130 -140 0 -140 0 0 -130z" class="svg-elem-27"></path>
            <path d="M650 945 l0 -25 135 0 135 0 0 25 0 25 -135 0 -135 0 0 -25z" class="svg-elem-28"></path>
            <path d="M1080 820 l0 -70 135 0 135 0 0 70 0 70 -135 0 -135 0 0 -70z" class="svg-elem-29"></path>
            <path d="M220 800 l0 -81 138 3 137 3 3 78 3 77 -141 0 -140 0 0 -80z" class="svg-elem-30"></path>
            <path d="M650 745 l0 -105 135 0 135 0 0 105 0 105 -135 0 -135 0 0 -105z" class="svg-elem-31"></path>
            <path d="M1080 600 l0 -100 135 0 135 0 0 100 0 100 -135 0 -135 0 0 -100z" class="svg-elem-32"></path>
            <path d="M1930 525 l0 -105 140 0 140 0 0 105 0 105 -140 0 -140 0 0 -105z" class="svg-elem-33"></path>
            <path d="M220 505 l0 -95 140 0 140 0 0 95 0 95 -140 0 -140 0 0 -95z" class="svg-elem-34"></path>
            <path d="M1510 572 c0 -71 122 -116 206 -76 32 15 64 57 64 84 0 6 -47 10 -135 10 -123 0 -135 -2 -135 -18z" class="svg-elem-35"></path>
            <path d="M650 531 c0 -23 42 -68 75 -81 83 -32 195 16 195 82 0 16 -12 18 -135 18 -125 0 -135 -1 -135 -19z" class="svg-elem-36"></path>
            <path d="M220 356 c0 -8 12 -28 26 -45 44 -52 140 -64 201 -24 21 14 53 61 53 78 0 3 -63 5 -140 5 -114 0 -140 -3 -140 -14z" class="svg-elem-37"></path>
            <path d="M1076 342 c-2 -4 2 -21 10 -38 38 -79 175 -93 237 -24 15 17 27 39 27 50 0 19 -7 20 -134 20 -74 0 -137 -4 -140 -8z" class="svg-elem-38"></path>
            <path d="M1930 314 c0 -27 63 -82 103 -89 76 -14 155 24 172 83 l6 22 -140 0 c-123 0 -141 -2 -141 -16z" class="svg-elem-39"></path>
          </g>
        </svg>
      </div>

      <!-- Welcome Message -->
      <h2 class="welcome-text">
        {{ 'SPLASH.WELCOME' | translate }}
      </h2>

      <!-- Loading Tip -->
      <div class="loading-tip">
        <p class="tip-text">
          {{ currentTip() | translate }}
        </p>
      </div>

      <!-- Progress Bar -->
      <div class="progress-container">
        <p-progressBar
          class="progress-bar"
          [value]="progress()"
          [showValue]="false"
        />
        <span class="progress-text">{{ progress() }}%</span>
      </div>

    </div>

    <!-- Version Display (Lower Right Corner) -->
    <div class="version-corner">
      <span class="version-text">v{{ version }}</span>
    </div>
  </div>
}
